module.exports = __webpack_public_path__ + "img/banner-devsecops.d0c026f5.jpeg";